import type { IUiThreeDPresentation } from './Interfaces';
import * as THREE from 'three';

export class StubPresentation implements IUiThreeDPresentation {
  private _object: THREE.Object3D = new THREE.Object3D();

  public get3dObject(): THREE.Object3D {
    return this._object;
  }

  public dispose(): void {
    // noop
  }
}
